import { Directive, HostListener, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

export interface FocusOnFirstInvalidField {
	formGroup: UntypedFormGroup;
	formWrapper: HTMLElement;
}

/* This directive will only work if you attach this directive into a form submit button */
@Directive({
	selector: '[focusOnFirstInvalidField]',
	standalone: false
})
export class FocusOnFirstInvalidFieldDirective {
	@Input()
	public focusOnFirstInvalidField: FocusOnFirstInvalidField;

	@HostListener('click')
	public handle () {
		const formGroup = this.focusOnFirstInvalidField.formGroup;
		const wrapper = this.focusOnFirstInvalidField.formWrapper;
		formGroup.markAllAsTouched();

		Object.values(formGroup.controls).forEach((control) => {
			if (control.invalid) {
				control.markAsTouched();
				control.markAsDirty();
			}
		});

		const invalidElement = this.getFirstInvalidElement(wrapper, formGroup);
		this.focusElement(invalidElement);
	}

	private getFirstInvalidElement (wrapper: HTMLElement, formGroup: UntypedFormGroup): HTMLElement | null {
		const formControls = Array.from(wrapper.querySelectorAll<HTMLElement>('[formControlName]'));
		const invalidControl = formControls.find((element) => {
			const formControlName = element.getAttribute('formControlName');

			return formControlName != null && formGroup.controls[formControlName]?.invalid;
		});

		if (invalidControl) {
			return invalidControl;
		}

		return wrapper.querySelector<HTMLElement>(
			'input.ng-invalid, textarea.ng-invalid, select.ng-invalid, mat-select.ng-invalid, mat-checkbox.ng-invalid, mat-radio-group.ng-invalid, user-form-field.ng-invalid'
		);
	}

	private focusElement (element: HTMLElement | null): void {
		if (element == null) {
			return;
		}

		if (element.tagName === 'MAT-CHECKBOX' || element.tagName === 'MAT-RADIO-GROUP' || element.tagName === 'USER-FORM-FIELD') {
			element.querySelector<HTMLElement>('input')?.focus();
			return;
		}

		element.focus();
	}
}
